import {logoutIfInvalid} from '../../services/session/logoutOnUnauthorized'
import appConfig from '../../config';

function resolveHost(url) {
  // IE safe version
  // https://stackoverflow.com/questions/470832/getting-an-absolute-url-from-a-relative-one-ie6-issue/22918332#22918332
  var div = document.createElement('div');
  div.innerHTML = "<a></a>";
  div.firstChild.href = url; // Ensures that the href is properly escaped
  div.innerHTML = div.innerHTML; // Run the current innerHTML back through the parser
  return div.firstChild.host || window.location.host;
}

const apiHost = resolveHost(appConfig.apiUrl)

angular.module('clientDashboardApp.auth.authInterceptor', [
  'clientDashboardApp.auth.authTokenStore'
]).factory("authInterceptor", AuthInterceptor);

function AuthInterceptor($q, authTokenStore) {
  return {
    request: function (config) {

      const initialHost = resolveHost(config.url);
      // default all relative angular api requests to the api, not the asset server
      if (initialHost === resolveHost("") && !config.url.includes(initialHost)) {
        const sep = config.url[0] === "/" ? "" : "/"
        config.url = appConfig.apiUrl + sep + config.url
      }

      const host = resolveHost(config.url)

      config.headers = config.headers || {};
      var authToken = authTokenStore.getSSOAuthToken() || authTokenStore.getUserAuthToken();
      if (authToken && host === apiHost) {
        config.headers.Authorization = authToken;
      }
      return config;

    },
    responseError: function (response) {
      if (response.status === 401) {
        logoutIfInvalid()
      }
      return $q.reject(response);
    }
  };
}
